import axios from "@/plugins/axios.js";
import store from "@/store";

export const state = {
  info: null,
  stores: null,
  isReady: false,
  slug: null,
};

export const mutations = {
  SET_APP_INFO: (state, data) => {
    state.info = data;
  },
  SET_STORES_LIST: (state, data) => {
    state.stores = data;
  },
  SET_IS_READY: (state, data) => {
    state.isReady = data;
  },
  SET_SLUG: (state, data) => {
    state.slug = data;
  },
};

export const actions = {
  setAppInfo({ commit }, payload) {
    commit("SET_APP_INFO", payload);
  },
  async loadAppInfo({ commit }) {
    const { data } = await axios.get("/app/layouts");
    commit("SET_APP_INFO", data.data);
  },
  async loadStoresList({ commit }) {
    store.dispatch("loading/start");
    const { data } = await axios.get("/app/stores");
    commit("SET_STORES_LIST", data.data);
    store.dispatch("loading/done");
  },
  setIsReady({ commit }, payload) {
    commit("SET_IS_READY", payload);
  },
  setSlug({ commit }, payload) {
    commit("SET_SLUG", payload);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
